module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length > 0) ? _c('div', {
    staticClass: "mt10"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('div', {
      style: (_vm.styleObject)
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "height": _vm.size.height,
        "alt": item.aname,
        "width": _vm.size.width
      }
    })])], 1)])
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c883ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/cross-bar-ad/index.vue
// module id = 1636
// module chunks = 1